import { SuccessNotifications } from 'components/Notification';
import React, { FC, useEffect } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { trackDisplaySuccessUnsubscribeBanner } from '../../../../services/userActionEvents';
import { ActionNotificationMessageProps } from '../../types';
import { Stack, Text } from '@atlaskit/primitives';
import { LearnMoreAction } from '../Actions';

const SuccessUnsubscribeKeys: FC<ActionNotificationMessageProps> = ({ data, onClose }) => {
  const { translate } = useTranslation();

  // get list of subscriptions the user unsubscribed from by parsing the query params
  const searchParams = new URLSearchParams(window.location.search);
  const subscriptions = searchParams.get('key')?.split(',');

  useEffect(() => {
    subscriptions?.map((subscription) => trackDisplaySuccessUnsubscribeBanner({ source: subscription }));
  }, [subscriptions]);
  return (
    <div data-testid={'unsubscribe-key-success'}>
      <SuccessNotifications
        title={translate(translationKeys.NOTIFICATION_UNSUBSCRIBE_MESSAGE_TITLE, { subscriptions: data || '' })}
        onClose={onClose}
        actions={[<LearnMoreAction key={'learn-more'} />]}
      >
        <Stack space='space.100'>
          <Text as='p'>{translate(translationKeys.NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_PRIMARY)}</Text>
          <Text as='p'>{translate(translationKeys.NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_SECONDARY)}</Text>
        </Stack>
        <Text size='small'>{translate(translationKeys.NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_TERTIARY)}</Text>
      </SuccessNotifications>
    </div>
  );
};

export default SuccessUnsubscribeKeys;
